import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { height, overflow } from 'styled-system';

import { Flex } from 'common/components/Flex';

const UnstyledContainer = styled(Flex)<any>`
  ${height};
  ${overflow};
`;

const Container = (props: ComponentProps<typeof UnstyledContainer>) => (
  <UnstyledContainer flexDirection="column" overflow="hidden" height="100%" {...props} />
);

export default Container;
